import { Typography, ChevronNavigation } from '@workspace/ui/common';
import { cn } from '@workspace/lib';

interface ProductCarouselHeaderProps {
  heading: string | null;
  showMobileNav: boolean;
  showDesktopNav: boolean;
  onNextMobile: () => void;
  onPrevMobile: () => void;
  onNextDesktop: () => void;
  onPrevDesktop: () => void;
}

export function ProductCarouselHeader({
  heading,
  showMobileNav,
  showDesktopNav,
  onNextMobile,
  onPrevMobile,
  onNextDesktop,
  onPrevDesktop,
}: ProductCarouselHeaderProps) {
  return (
    <div className={cn('flex flex-col md:flex-row justify-between items-start md:items-center gap-sm mb-sm md:mb-xl')}>
      {heading && (
        <Typography variant="h3" className="tracking-tight text-left w-full break-words">
          {heading}
        </Typography>
      )}
      {/* Desktop chevrons */}
      {showDesktopNav && (
        <div className="hidden md:block">
          <ChevronNavigation goNext={onNextDesktop} goPrev={onPrevDesktop} />
        </div>
      )}
      {/* Mobile chevrons - based on group count */}
      {showMobileNav && (
        <div className="md:hidden">
          <ChevronNavigation goNext={onNextMobile} goPrev={onPrevMobile} />
        </div>
      )}
    </div>
  );
}
